import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import _ from 'lodash';
import CustomModal from '../../../CustomModal/CustomModal';
import { SupportSheetSelector, setHirePaymentStatus, setShowEditHireIndex } from '../../reducers/SupportSheetReducer';
import { Button, Grid, TextField } from '@mui/material';
import NumberFormatCustom from '../../../NumberFormatCustom/NumberFormatCustom';
import { getDefaultHidePaymentStatus } from './SupportSheetHirePaymentStatus';
import SupportSheetHirePaymentStatusModel from './models/SupportSheetHidePaymentStatusModel';

const SupportSheetEditHireIndexModal: React.FunctionComponent = () => {
    const dispatch = useDispatch();
    const supportSheetData = useSelector(SupportSheetSelector);
    const [hireNumber, setHireNumber] = useState(-1);

    return (
        <CustomModal
            open={supportSheetData.showEditHireIndex}
            onClose={() => {
                dispatch(setShowEditHireIndex(false));
            }}
        >
            <Grid container>
                <Grid item xs={10}>
                    <TextField
                        fullWidth
                        className="cargo-input-component"
                        label="Hire Number"
                        InputProps={{
                            inputComponent: NumberFormatCustom as any,
                        }}
                        value={hireNumber == -1 ? supportSheetData.currentHire.index + 1 : hireNumber + 1}
                        onChange={(event) => {
                            let value = event.target.value.length == 0 ? 0 : parseFloat(event.target.value);
                            setHireNumber(value - 1);
                        }}
                    >
                    </TextField>
                </Grid>
                <Grid item xs={2}>
                    <Button
                        onClick={() => {
                            dispatch(setShowEditHireIndex(false));

                            if (hireNumber == -1) {
                                return;
                            }

                            let hirePaymentStatus = null;
                            if (!supportSheetData.model.hirePaymentStatus || supportSheetData.model.hirePaymentStatus.length == 0) {
                                hirePaymentStatus = getDefaultHidePaymentStatus();
                            } else {
                                hirePaymentStatus = JSON.parse(supportSheetData.model.hirePaymentStatus) as SupportSheetHirePaymentStatusModel[];
                            }

                            let editedHireNumber = hireNumber;

                            for (let index = supportSheetData.currentHireIndex; index < hirePaymentStatus.length; index++) {
                                hirePaymentStatus[index].index = editedHireNumber;
                                editedHireNumber++;
                            }

                            dispatch(setHirePaymentStatus(JSON.stringify(hirePaymentStatus)));
                            setHireNumber(-1);
                        }}
                    >Save</Button>
                </Grid>
            </Grid>

        </CustomModal>
    )
};

export default SupportSheetEditHireIndexModal;